import { Ampli, Event, EventOptions, LoadOptions, PromiseResult, Result, IdentifyProperties } from "@/ampli";
import * as _descope_core_js_sdk from '@descope/core-js-sdk';

export interface AnalyticsUser {
    userId: string;
    email: string;
    name: string;
}

export interface Analytics {
    initialize: () => Promise<void>;
    identify: (userId: string | undefined, properties?: IdentifyProperties, options?: EventOptions) => PromiseResult<Result>;
    getTrackerInstance: (user?: AnalyticsUser) => any;
}

export const getVoidPromiseResult = (): PromiseResult<Result> => {
    return { promise: Promise.resolve() };
};

const useLocalAnalytics = process.env.NEXT_PUBLIC_DEV_USE_LOCAL_ANALYTICS === 'true';

export class NoopAnalytics extends Ampli implements Analytics {
    async initialize(): Promise<void> {
        if (useLocalAnalytics) {
            console.log('NoopAnalytics: initialize');
        }
    }

    identify(userId: string | undefined, properties?: IdentifyProperties, options?: EventOptions): PromiseResult<Result> {
        if (useLocalAnalytics) {
            console.log('NoopAnalytics: identify', userId, properties, options);
        }
        return getVoidPromiseResult();
    }

    getTrackerInstance(user?: AnalyticsUser): this {
        if (useLocalAnalytics) {
            console.log('NoopAnalytics: getTrackerInstance', user);
        }
        return this;
    }

    load(options: LoadOptions): PromiseResult<void> {
        if (useLocalAnalytics) {
            console.log('NoopAnalytics: load', options);
        }
        return { promise: Promise.resolve() };
    }

    track(event: Event, options?: EventOptions): PromiseResult<Result> {
        if (useLocalAnalytics) {
            console.log('NoopAnalytics: track', event, options);
        }
        return getVoidPromiseResult();
    }
}
